import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import {MediaTypeUtil} from '../../services/MediaTypeUtil';
import {FormControl, FormGroup} from '@angular/forms';
import {
  financialModelErrorToTooltip,
  GetProjectsFinancialModel
} from '../../services/project-details/GetProjectsFinancialModel';
import {MatDialog} from '@angular/material/dialog';
import {
  FinancialModelUploadDialogComponent
} from './financial-model-upload-dialog/financial-model-upload-dialog.component';

@Component({
  selector: 'digires-financial-model',
  templateUrl: './financial-model.component.html',
  styleUrls: ['./financial-model.component.scss']
})
export class FinancialModelComponent implements OnChanges {

  readonly EXCEL_ONLY = MediaTypeUtil.EXCEL_TYPES;
  readonly financialModelErrorToTooltip = financialModelErrorToTooltip;

  @Output() fileSelect: EventEmitter<FinancialModelFile> = new EventEmitter<FinancialModelFile>();
  @Output() fileDelete: EventEmitter<void> = new EventEmitter<void>();
  @Output() keyDataChangeReasonChanged: EventEmitter<string> = new EventEmitter<string>();
  @Input() projectId: string;
  @Input() financialModel: GetProjectsFinancialModel;
  @Input() canEdit: boolean;
  @Input() canDelete: boolean;

  financialModelDataFg: FormGroup;
  financialModelInitialData: {
    preferredScenarioTitle: string,
    preferredScenarioNumber: string,
    type: string,
    version: string
  };
  fileId: string;

  loading: boolean;
  checkedFile: File;

  constructor(private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.financialModel) {
      this.fileId = this.financialModel?.fileId;
      if (changes.financialModel.firstChange) {
        this.financialModelDataFg = new FormGroup({
          preferredScenarioTitle: new FormControl(this.financialModel?.preferredScenarioTitle),
          preferredScenarioNumber: new FormControl(this.financialModel?.preferredScenarioNumber),
          type: new FormControl(this.financialModel?.type),
          version: new FormControl(this.financialModel?.version),
        });
      } else {
        this.financialModelDataFg.patchValue({
          preferredScenarioTitle: this.financialModel?.preferredScenarioTitle,
          preferredScenarioNumber: this.financialModel?.preferredScenarioNumber,
          type: this.financialModel?.type,
          version: this.financialModel?.version,
        });
      }
      this.financialModelInitialData = this.financialModelDataFg.value;
    } else {
      this.fileId = null;
    }
  }

  onUpload(file: File) {
    this.fileSelect.emit({
      status: 'UNCHECKED',
      file: file,
    });
    if (!file) {
      return;
    }
    this.dialog.open(
      FinancialModelUploadDialogComponent,
      {
        hasBackdrop: true,
        height: '80vh',
        width: '90vw',
        data: {
          projectId: this.projectId,
          file: file,
        }
      }
    )
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.financialModel = result.financialModel;
          this.keyDataChangeReasonChanged.emit(result.keyDataChangeReason);
          this.financialModelDataFg.patchValue({
            preferredScenarioTitle: this.financialModel.preferredScenarioTitle,
            preferredScenarioNumber: this.financialModel.preferredScenarioNumber,
            type: this.financialModel.type,
            version: this.financialModel.version,
          });
          this.checkedFile = file;
          this.fileSelect.emit({
            status: 'CHECKED',
            file: file,
          });
        } else {
          this.fileSelect.emit({
            status: 'FAILED',
            file: file,
          });
        }
      });
  }

  onCopyErrors(): void {
    let txtTobeCopied = '';
    for (const error of this.financialModel.errors) {
      txtTobeCopied += error.propertyName + ' - ' + error.errorMessage + '\n';
    }
    navigator.clipboard.writeText(txtTobeCopied);
  }

}
export interface FinancialModelFile {
  status: 'CHECKED' | 'UNCHECKED' | 'FAILED';
  file: File;
}
